import { InjectionToken } from "@angular/core";

export const defaultPlaceholder = "-";

export const NO_VALUE_PLACEHOLDER = new InjectionToken<string>(
  "NO_VALUE_PLACEHOLDER"
);
